import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom-v5'
import AdminHeader from '../../components/admin-header'
import FixedFooter from '../../components/fixed-footer'
import { useCampaign } from '../../hooks/use-campaign'
import style from '../../style/pages/admin-checked.module.scss'

const AdminChecked = () => {
  const { campaignCodeFromUrl } = useCampaign()
  const { t } = useTranslation()

  return (
    <main className={style.main}>
      <AdminHeader />
      <img src="https://cdn.moneynet.tw/common/images/smile.png" alt="order complete" />
      <h2 className={style.message}>{t('order.completedMessage')}</h2>
      <FixedFooter>
        <Link className={style['back-to-scan']} to={`/admin/${campaignCodeFromUrl}/admin-login`}>
          {t('button.returnScanningPage')}
        </Link>
      </FixedFooter>
    </main>
  )
}

export default AdminChecked
